import { useEffect, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";

import { useReport } from "../../context/report";

import { GraficoProducaoReal } from "./GraficoProducaoReal";

export default function ProducaoReal() {
    const [charts, setCharts] = useState([]);
    const [eficiencia, setEficiencia] = useState("");

    const { data } = useReport();

    useEffect(() => {
        let _charts = [];
        let _data = [...data.producoes];
        let _grupos = [...data.grupos];

        _grupos.forEach((grupo) => {
            let chart = {
                "grupo": grupo,
                "chartData": {},
                "periodo": data.periodo
            };

            let filteredByGrupo = _data.filter((element) => {
                return parseInt(element.grupo) === parseInt(grupo);
            });

            let dates = [];
            let turmas = [];

            filteredByGrupo.forEach((item) => {
                if(!dates.includes(item.dataf)) {
                    dates.push(item.dataf);
                }

                if(!turmas.includes(item.turma)) {
                    turmas.push(item.turma);
                }
            });
    
            let datasets = [];
           
            turmas.forEach((turma) => {
                let borders = [];
                let colors = [];
                let dataChart = [];

                let filteredByTurma = filteredByGrupo.filter((element) => {
                    return element.turma === turma;
                });

                dates.forEach((date) => {
                    let searchTurma = filteredByTurma.find((element) => {
                        return element.dataf === date;
                    });

                    let border = "#fff";
                    let color = filteredByTurma[0].hex;

                    if(searchTurma) {
                        dataChart.push(parseFloat(searchTurma.eficiencia));

                        if(parseFloat(eficiencia)) {
                            if(parseFloat(searchTurma.eficiencia) < eficiencia) {
                                border = "#c0392b";
                                color = "#c0392b";
                            } else {
                                border = "#fff";
                            }
                        }
        
                    } else {
                        dataChart.push(NaN);
                    }

                    borders.push(border);
                    colors.push(color);

                });

                datasets.push({
                    label: "Turma " + turma,
                    data: dataChart,
                    backgroundColor: colors,
                    borderColor: borders,
                    borderRadius: 2,
                    borderWidth: 2
                });
            });
    
            const chartData = {
                labels: dates,
                datasets: datasets
            }

            chart.chartData = chartData;
            _charts.push(chart);
        });
        setCharts(_charts);
    }, [data, eficiencia]);

    return (
        <div>
            <div className="p-d-flex p-flex-row p-jc-start p-m-1">
                <div className="p-fluid">
                    <label htmlFor="eficiencia_minima">Eficiência Mínima</label>
                    <InputText 
                        onChange={e => setEficiencia(e.target.value)}
                        placeholder="Exemplo: 85"
                        type="number"
                        value={eficiencia}
                    />
                </div>
            </div>
            <Panel collapsed header="GRÁFICO DE PRODUÇÃO POR DIA E TURMA">
                {charts.map((chart, index) => (
                    <GraficoProducaoReal key={`chart${index}`} chart={chart} />
                ))}
            </Panel>
            <Panel collapsed header="RELATÓRIO DE PRODUÇÃO POR DIA E TURMA">
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    groupRowsBy="grupo"
                    rowGroupMode="subheader"
                    rowGroupHeaderTemplate={(data) => (
                        <h4>{data.grupo}</h4>
                    )}
                    responsiveLayout="scroll"
                    size="small"
                    value={data.dados}
                >
                    <Column header="Data" field="data" sortable />
                    {data?.colunas.map((item, index) => (
                        <Column header={"Turma " + String(item).replace("turma", "").toUpperCase()} key={`turma${index}`} sortable sortField={item} body={(rowData) => {
                            if(rowData[item]) {
                                return Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(rowData[item]);
                            }
                        }} /> 
                    ))}
                </DataTable>
            </Panel>
        </div>
    )
}